module.exports = __webpack_public_path__ + "static/media/sofa.6ea5130f.svg";